import type { NudgeAccent } from "./types";

export const nudgeAccentStyles: Record<
  NudgeAccent,
  { rail: string; icon: string; card: string }
> = {
  primary: {
    rail: "border-l-primary",
    icon: "bg-primary/10 text-primary",
    card: "bg-primary/[0.03]",
  },
  warning: {
    rail: "border-l-amber-500",
    icon: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
    card: "bg-amber-500/[0.04]",
  },
  danger: {
    rail: "border-l-destructive",
    icon: "bg-destructive/10 text-destructive",
    card: "bg-destructive/[0.04]",
  },
  info: {
    rail: "border-l-sky-500",
    icon: "bg-sky-500/10 text-sky-600 dark:text-sky-400",
    card: "bg-sky-500/[0.04]",
  },
};
